"use strict";

module.exports = {
  bindings: {
    patient: '<'
  },
  template: require('./patient-masterdata.html'),
  controller: function () {
    var ctrl = this;

    ctrl.gender = {
      "MALE": 'männlich',
      "FEMALE": 'weiblich'
    };
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/tile-patient-masterdata/patient-masterdata.component.js